import { render } from "./ReceivablesTab.vue?vue&type=template&id=6f12f389"
import script from "./ReceivablesTab.vue?vue&type=script&lang=js"
export * from "./ReceivablesTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__